import { createTheme } from "@mui/material";

let theme = createTheme({
  palette: {
    common: {
      main: "#000000",
      light: "#FFFFFF",
    },

    primary: {
      main: "#31B9B5",
    },

    secondary: {
      main: "#373973",
    },

    success: {
      main: "#30B085",
      light: "#30B08515",
      dark: "#00CB14",
    },

    warning: {
      main: "#FFB210",
      light: "#FFB21015",
    },

    info: {
      main: "#438BED",
      light: "#438BED15",
    },

    error: {
      main: "#D94166",
      light: "#D9416615",
    },
    A1: { main: "#31B9B530" },
    A8: { main: "#DBDBDB" },

    accent: {
      A1: "#31B9B530",
      A2: "#F5F9FA",
      A3: "#FAFAFA",
      A4: "#F97B34",
      A5: "#00000075",
      A6: "#22222275",
      A7: "#22222260",
      A8: "#DBDBDB",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "DMSans-Regular",
          paddingBottom: "5px",
          fontSize: "14px",
        },
      },
    },

    MuiAvatar: {
      styleOverrides: {
        root: {
          borderRadius: "100px",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: 'max-content',
          borderRadius: "50px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Inter-Bold",
          fontSize: "12px",
          letterSpacing: "0rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { fontFamily: "DMSans-Regular", borderRadius: "8px" },
        input: {
          padding: "16px 14px",
          fontSize: "16px",
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: "#31B9B5",
          color: "white",
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#657285',
          backgroundColor: '#E3F1FF',
        },
        arrow: {
          color: '#E3F1FF',
        }
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        body: {
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            backgroundColor: "#C4C4C440",
            width: "10px",
            borderRadius: 100,
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 100,
            backgroundColor: "#C4C4C4",
          },
          "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
          {
            backgroundColor: "#8b8b8b",
          },
          "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
          {
            backgroundColor: "#959595",
          },
          "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
          {
            backgroundColor: "#959595",
          },
        },
      },
    },

    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            cursor: 'pointer'
          }
        }
      }
    }
  },

  typography: {
    fontFamily: "DMSans-Regular",

    button: {
      fontFamily: "DMSans-Bold",
      fontSize: "18px",
      letterSpacing: " .1rem ",
      textTransform: "capitalize",
    },

    h1: {
      fontSize: "44px",
      fontFamily: "Inter-Bold",
    },
    h2: {
      fontSize: "32px",
      fontFamily: "Inter-Bold",
    },
    h3: {
      fontSize: "24px",
      fontFamily: "Inter-SemiBold",
    },
    h4: {
      fontSize: "20px",
      fontFamily: "Inter-SemiBold",
    },
    h5: {
      fontSize: "18px",
      fontFamily: "Inter-Medium",
    },
    h6: {
      fontSize: "16px",
      fontFamily: "Inter-Medium",
    },
    body1: {
      fontSize: "16px",
    },
    body2: {
      fontSize: "14px",
    },
    body3: {
      fontSize: "18px",
    },
    overline: {
      fontSize: "12px",
    },
    caption: {
      fontSize: "10px",
    },
  },
});

theme = {
  ...theme,
  typography: {
    ...theme.typography,
    h1: {
      ...theme.typography.h1,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "36px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "28px",
      },
    },
    h2: {
      ...theme.typography.h2,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "27px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "22px",
      },
    },
    h3: {
      ...theme.typography.h3,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "21px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "18px",
      },
    },
    h4: {
      ...theme.typography.h4,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "18px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "16px",
      },
    },
    h5: {
      ...theme.typography.h5,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "16px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "15px",
      },
    },
    h6: {
      ...theme.typography.h6,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "15px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "14px",
      },
    },
    body1: {
      ...theme.typography.body1,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "15px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "14px",
      },
    },
    body2: {
      ...theme.typography.body2,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "12px",
      },
    },
    body3: {
      ...theme.typography.body3,
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: "17px",
      },
      [theme.breakpoints.between("xs", "sm")]: {
        fontSize: "16px",
      },
    },


    // button: {
    //   ...theme.typography.body2,
    //   [theme.breakpoints.between("sm", "md")]: {
    //     fontFamily: "DMSans-Bold",
    //     fontSize: "14px",
    //     letterSpacing: " .1rem ",
    //     textTransform: "capitalize",
    //   },
    //   [theme.breakpoints.between("xs", "sm")]: {
    //     fontFamily: "DMSans-Bold",
    //     fontSize: "12px",
    //     letterSpacing: " .1rem ",
    //     textTransform: "capitalize",
    //   },
    // },
  },
};

export const kstheme = theme;
